export const useDomain = () => {
  const url = useRequestURL()

  const isFecDomain = /^(.*.)?ihreapotheken.de$/.test(url.hostname)

  return {
    isFecDomain,
  }
}
